import { createFileRoute } from "@tanstack/react-router";
import { ReportsPage } from "@/projects/admin/pages/ReportsPage";

export const Route = createFileRoute("/admin/reports")({
  head: () => ({ meta: [{ title: "Reports — Admin" }] }),
  component: ReportsPage,
});
